module.exports = __webpack_public_path__ + "static/img/MO.5525e084.svg";